import React from "react";
import PropTypes from "prop-types";
import { HiMiniGiftTop } from "react-icons/hi2";
import { templates } from "./templateContants";
import "./ImageTemplate.css";
const ImageRenderer = ({ details, cta, templateIndex, scale, imageUrls }) => {
  if (!details) return <></>;
  // i think this check is for wishlists with no imageUrls?
  if(scale > 1 && details.title && ( !imageUrls || !imageUrls[details.title])) return <></>;

  const wishlistItems = details.wishlistItems;
  let noBorderRadius = true;

  // Ensure templateIndex is valid
  const isValidIndex =
    typeof templateIndex === "number" &&
    templateIndex >= 0 &&
    templateIndex < templates.length;
  const templateClass = isValidIndex
    ? templates[templateIndex]
    : "default-template";


  const scalingStyle = {
    "--wishlist-user-font": scale,
    "--font-scale": scale,
    "--font-scale-cta": scale,
    "--link-item-name-font-scale": scale * .6, 
    "--wl-item-margin-top": scale,
    "--font-currency-amount": scale,
    "--img-scale": scale,
    "--link-img-scale": scale,
    "--logo-scale": scale * 1.1,
    "--name-topmargin": scale,
    "--template-height": scale,
    "--template-width": scale,
  };

  return (
    <div
      className={`image-template ${templateClass} ${
        noBorderRadius ? "no-border-radius" : ""
      }`}
      style={scale !== 1 ? scalingStyle : {}}
    >
      {details.type === "item" && (
        <>
          <div className="thumbnail-items-container">
            <div className="cta-headline-container">
              <h3 className="cta-headline">{cta}</h3>
            </div>
            <div className="img-container">
              {imageUrls && imageUrls[details.title] ? (
                <img decoding="sync" crossOrigin="anonymous" className="item-img" src={imageUrls[details.title]} alt="" />
              ) : (
                <img className="item-img" src={details.photo} alt="" />
              )
              }
            </div>
            <div className="item-details-container">
              <h3 className="item-details-img-temp">{details.title}</h3>
            </div>
            <div className="thumbnail-logo-container">
              <HiMiniGiftTop className="link-logo" />
            </div>
          </div>
        </>
      )}
      {details.type === "currency" && (
        <>
          <div className="thumbnail-items-container">
            <div className="cta-headline-container">
              <h3 className="cta-headline">{cta}</h3>
            </div>
            <div className="currency-amount">
              <h4>${details.amount}</h4>
            </div>
            {details.giveorreceive === "give" && (
              <div className="currency-details-container">
                <p>{details.remainingQuantity} available</p>
              </div>
            )}
            <div className="thumbnail-logo-container">
              <HiMiniGiftTop className="link-logo" />
            </div>
          </div>
        </>
      )}
      {details.type === "wishlist" && (
        <>
          <div className="thumbnail-items-container">
            <div className="wishlist-username-container">
              <h3 className="wishlist-username">
                {details.username}&apos;s wishlist
              </h3>
            </div>
              {Array.isArray(wishlistItems) && wishlistItems.length > 0 ? (
                wishlistItems.map((item, index) => (
                  <div key={index} className="wishlist-item">
                    <div className="wishlist-item-img-container">
                      {imageUrls && imageUrls[item.name] ? (
                        <img
                          src={imageUrls[item.name]}
                          alt={`wishlist item ${index}`}
                          className="wishlist-item-img"
                          crossOrigin="anonymous"
                          decoding="sync" 
                        />
                      ) : (
                        <img
                          src={item.imageUrl}
                          alt={`wishlist item ${index}`}
                          className="wishlist-item-img"
                          crossOrigin="anonymous"

                        />
                    )}
                    </div>
                    <div className="wishlist-item-name-container">
                      {scale > 1 ? (
                        <p className="wishlist-item-name">{item.name}</p>
                      ) : (
                        <p className="wishlist-item-name">
                          {item.name.split(" ").slice(0, 5).join(" ")}
                          {item.name.split(" ").length > 5 && "..."}
                        </p>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p className="wishlist-item-name">No items within the wishlist</p>
              )}
            
            <div className="thumbnail-logo-container">
              <HiMiniGiftTop className="wishlist-logo" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

ImageRenderer.propTypes = {
  details: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    amount: PropTypes.number,
    giveorreceive: PropTypes.string,
    remainingQuantity: PropTypes.number,
    initialQuantity: PropTypes.number,
    photo: PropTypes.string,
    username: PropTypes.string,
    wishlistItems: PropTypes.array,
  }),
  cta: PropTypes.string,
  templateIndex: PropTypes.number,
  scale: PropTypes.number,
  sendToServer: PropTypes.bool,
  onImageLoad: PropTypes.func,
  imageUrls: PropTypes.object,
};

export default ImageRenderer;
